<template>
  <div id="register">
    <PageTitle title="Registreren - stap 2/2"></PageTitle>
    <form @submit.prevent>
      <!-- <Storage path="avatars/" v-on:setUrl='setUrl' v-on:setFilename="setFilename" imageOnly></Storage> -->
      <div class="form-group">
        <h3>Persoonlijke informatie</h3>
        <span>Laat je collega's vast weten wie jij bent. Later kun je nog een avatar toevoegen.</span>
      </div>
      <div class="row mb-2">
        <div class="col">
          <label for="title">voornaam</label>
          <input type="text" class="form-control" placeholder="Abe" v-model="firstname" />
        </div>
        <div class="col">
          <label for="title">achternaam</label>
          <input type="text" class="form-control" placeholder="de Vries" v-model="lastname" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <label for="title">Telefoonnr</label>
          <input type="text" class="form-control" placeholder="0612345678" v-model="phonenumber" />
        </div>
        <div class="col">
          <label for="title">functie</label>
          <input type="text" class="form-control" placeholder="HR medewerker" v-model="position" />
        </div>
      </div>
      <div class="form-group">
        <label for="section">Vertel kort iets over jezelf</label>
        <textarea class="form-control" id="section" v-model="bio" rows="5"></textarea>
      </div>
      <div class="form-group">
        <h3>Bedrijfsinformatie</h3>
        <span>Vul alvast de hoofdgegevens van je bedrijf in. Later kun je meerdere vestigingen toevoegen.</span>
      </div>
      <div class="row mb-2">
        <div class="col">
          <label for="title">Bedrijfsnaam</label>
          <input type="text" class="form-control" placeholder="mijn bedrijf" v-model="name" />
        </div>
        <div class="col">
          <label for="title">Telefoonnr</label>
          <input type="text" class="form-control" placeholder="0851231231" v-model="company_phonenumber" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <label for="title">adres</label>
          <input type="text" class="form-control" placeholder="straat en huisnummer" v-model="address" />
        </div>
        <div class="col">
          <label for="title">postcode</label>
          <input type="text" class="form-control" placeholder="8888AA" v-model="zipcode" />
        </div>
        <div class="col">
          <label for="title">plaats</label>
          <input type="text" class="form-control" placeholder="Zwolle" v-model="city" />
        </div>
      </div>
      <div class="form-group mt-4">
        <button @click="cancel" class="btn btn-light mr-2">Annuleren</button>
        <button @click="saveItem" class="btn btn-success">Opslaan</button>
      </div>
    </form>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from "@/components/PageTitle.vue";
import { mapState } from "vuex";

export default {
  name: "register",
  components: {
    PageTitle
  },
  computed: {
    ...mapState(["currentUser"])
  },
  data() {
    return {
      // user
      cid: "",
      firstname: "",
      lastname: "",
      phonenumber: "",
      position: "",
      bio: "",
      email: "",
      // company
      name: '',
      address: '',
      company_phonenumber: '',
      city: '',
      zipcode: "",
    };
  },
  methods: {
    saveItem() {
      var now = new Date();
      // first save the company data, then get the uid and add that to the userdata
      fb.companiesCollection
        .add({
          date_created: now.toISOString(),
          status: "not validated",
          name: this.name,
          address: this.address,
          phonenumber: this.company_phonenumber,
          city: this.city,
          placeholderImage: { url: "https://via.placeholder.com/150?text=Afb",
          filename: "nevermind"},
          companyImage: {
            url: "https://via.placeholder.com/600x400?text=upload+een+foto+van+je+bedrijf",
            filename: "nevermind"
          },
          zipcode: this.zipcode
        })
        .then(docRef => {
          this.cid = docRef.id;
          // now save the user information
          fb.usersCollection
            .add({
              date_created: now.toISOString(),
              roles: ["admin"],
              company: this.cid,
              firstname: this.firstname,
              lastname: this.lastname,
              bio: this.bio,
              phonenumber: this.phonenumber,
              positions: [this.position],
              email: this.currentUser.email
            })
            .then(docRef => {
              console.log(docRef);
              // cookie setten en naar home              
              this.$store.dispatch('fetchUserProfile')
            })
            .catch(error => {
              // when failed then roll back the company also TODO
              console.log(error);
            });
        })
        .catch(error => console.log(error));
    },
    cancel() {    
        // afbreken? Dan ook uit Auth???

    }
  }
};
</script>